import React, { useContext, useEffect, useState } from 'react'
import { leftArrow, logo, logoAltera, rigthArrow } from '../../images'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { NavBarCollapsableContext } from '../../helpers/context'
import { NAVBAR_OPTIONS } from '../../helpers/options/options'
import Tooltip from '@mui/material/Tooltip'
import { MenuItem, MenuList } from '@mui/material'

type MenuOption = {
  to: string
  label: string
  background?: string
  img: string
  imgActive: string
  item: string
}

/** CollapsableMenu  this component return the collapsable menu on the left */
const CollapsableMenu = () => {
  const classContext = useContext(NavBarCollapsableContext)
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)
  const [indexActive, setIndexActive] = useState(-1)
  let navigate = useNavigate()
  let menuCompleted = ['/login', '/sign-up']
  const userName = sessionStorage.getItem('user_name')
  const [userLogged, setUserLogged] = useState(false)
  let location = useLocation()
  const path = location.pathname
  const menuCollapsable = !menuCompleted.includes(path)
  const [showMenu, setShowMenu] = useState(false)
  const principalView = '/dashboard'

  useEffect(() => {
    if (userName) {
      setUserLogged(true)
    }
  }, [userName])

  useEffect(() => {
    if (open) {
      const updatedClasses = {
        navbar_opened: true,
        navbar_padding_left:
          path !== '/settings'
            ? 'navbar-open-padding-left'
            : 'navbar-open-padding-left-settings',
        navbar_arrow_margin: 'navbar-arrow-open-margin',
        navbar_width: 'navbar-open-width',
      }
      classContext.setClasses(updatedClasses)
    } else {
      const updatedClasses = {
        navbar_opened: false,
        navbar_padding_left:
          path !== '/settings'
            ? 'navbar-close-padding-left'
            : 'navbar-close-padding-left-settings',
        navbar_arrow_margin: 'navbar-arrow-close-margin',
        navbar_width: 'navbar-close-width',
      }
      classContext.setClasses(updatedClasses)
    }
  }, [open])

  const handleCollapsable = () => {
    setOpen(!open)
  }

  const goTo = (url: string) => {
    setShowMenu(false)
    navigate(url)
  }
  const handleMenuShow = (index: number) => {
    setShowMenu(!showMenu)
    setIndexActive(index)
  }

  const handleActive = (index: number) => {
    setIndexActive(index)
  }

  const handleInactive = () => {
    setIndexActive(-1)
  }

  const Menu = () => {
    return (
      <div
        className={`container-option-extra-qr-link ${
          open ? 'left-25' : 'left-6'
        }`}
      >
        <button
          className='button-option-extra'
          onClick={() => goTo('create-new-link')}
        >
          <span className='option-extra'>{`${t('LINK')}`}</span>
        </button>
        <hr></hr>
        <button
          className='button-option-extra'
          onClick={() => goTo('create-new-qr-code')}
        >
          <span className='option-extra'>{`${t('QR_CODE')}`}</span>
        </button>
      </div>
    )
  }

  return (
    <>
      {userLogged && menuCollapsable && (
        <div
          id='mySidebar'
          className={`sidebar-left ${classContext.classes.navbar_width}`}
        >
          <nav className={`side-nav ${classContext.classes.navbar_width}`}>
            <div
              className='sidebar-logo'
              onClick={() => navigate(principalView)}
            >
              <img
                src={!open ? logo : logoAltera}
                alt='Logo'
                className={!open ? 'img-logo' : 'img-logo-altera'}
              />
            </div>
            <div className='menu-logo'>
              <img
                src={open ? leftArrow : rigthArrow}
                alt='Logo'
                className={`arrow-collapsable ${classContext.classes.navbar_arrow_margin}`}
                onClick={() => handleCollapsable()}
              />
            </div>

            <hr></hr>
            <div className='menu'>
              <div className='content'>
                <MenuList>
                  {NAVBAR_OPTIONS.map((value: MenuOption, index: number) => (
                    <div key={value.item}>
                      {value.to === '/settings' && (
                        <hr className='settings-divider' />
                      )}
                      <MenuItem
                        onClick={() =>
                          value.item === 'create_new'
                            ? handleMenuShow(index)
                            : goTo(value.to)
                        }
                        onMouseEnter={() => handleActive(index)}
                        onMouseLeave={handleInactive}
                        selected={value.to === path || index === indexActive}
                        className={`menu-item ${
                          value.to === path ? value.background : ''
                        } ${open ? 'menu-open-rounded' : 'menu-close-rounded'}`}
                      >
                        <div className='icon-container'>
                          <img
                            className='icon'
                            src={
                              index === indexActive || value.to === path
                                ? value.imgActive
                                : value.img
                            }
                            alt={value.item}
                          />
                          {open && (
                            <span className='navbar-icon' title={value.item}>
                              {`${t(value.label)}`}
                            </span>
                          )}
                        </div>
                      </MenuItem>
                    </div>
                  ))}
                  {showMenu && <Menu />}
                </MenuList>
              </div>
            </div>
          </nav>
        </div>
      )}
    </>
  )
}

export default CollapsableMenu
